// source: https://github.com/madou/react-sticky-header

import React, { Component } from 'react';
import "./stickyHeader.scss";

/** @import {StickyHeaderProps, StickyHeaderState} from './StickyHeaderTypes' */

const addEvent = (/** @type {string} */ event, /** @type {() => void} */ cb) => {
  window.addEventListener(event, cb, false);
  return () => window.removeEventListener(event, cb, false);
};

/** @extends {Component<StickyHeaderProps, StickyHeaderState>} */
class StickyHeader extends Component {
  /** @type {StickyHeaderState} */
  state = {
    isSticky: true,
  };

  /** @type {HTMLDivElement | null} */
  _fixed = null;

  /** @type {HTMLElement | null} */
  _root = null;

  /** @type {(() => void) | undefined} */
  _detach;

  componentDidMount() {
    this.initialise();
    // Force state change as we need to calculate the header background containers.
    this.setState({});
  }

  componentWillUnmount() {
    if (this._detach) this._detach();
  }

  calculateStickyState = () => {
    if (this._rafExecuting) {
      return;
    }

    this._rafExecuting = true;

    requestAnimationFrame(() => {
      const stickyHeaderHeight = this._fixed?.offsetHeight || 0;
      const headerContainer = this._root?.offsetHeight || 0;
      const headerContainerBoundingBox = this._root?.getBoundingClientRect();
      const stickyOffset = this.props.stickyOffset;
      const pastStickyThreshold = ((headerContainer + (headerContainerBoundingBox?.top || 0)) - stickyHeaderHeight) <= (stickyOffset || 0);

      if (pastStickyThreshold && !this.state.isSticky) {
        this.setState({
          isSticky: true,
        });

        //this.props.onSticky(true);
      } else if (!pastStickyThreshold && this.state.isSticky) {
        this.setState({
          isSticky: false,
        });

        //this.props.onSticky(false);
      }

      this._rafExecuting = false;
    });
  };

  onResize = () => {
    // We want to flush a re-render incase the children have changed size from CSS.
    this.setState({});

    // We want to check if because of a resize the header is now sticky or not.
    this.calculateStickyState();
  };

  initialise() {
    if (this._initialised) {
      return;
    }

    const detachScroll = addEvent('scroll', this.calculateStickyState);
    const detachResize = addEvent('resize', this.onResize);

    this._detach = () => {
      [detachScroll, detachResize].forEach((detatch) => detatch());
      this._initialised = false;
    };

    this.calculateStickyState();
    this._initialised = true;
  }

  render() {
    const backgroundUrl = this.props.backgroundImage && `url('${this.props.backgroundImage}')`;
    const headerClassName = `ReactStickyHeader_root${this.props.className ? ` ${this.props.className}` : ''}`;
    const rootClassName = `${headerClassName}${this.state.isSticky ? ' is-sticky' : ''}`;
    const headerContainerHeight = this._root && this._root.offsetHeight || 0;
    const fixedHeaderHeight = this._fixed && this._fixed.offsetHeight || 0;

    return (
      <header className={rootClassName} ref={(e) => (this._root = e)}>
        <div className="ReactStickyHeader_fixed" ref={(e) => (this._fixed = e)}>
          {this.props.children}
        </div>

        <div
          className="ReactStickyHeader_midground"
          style={{
            height: headerContainerHeight || fixedHeaderHeight,
            top: fixedHeaderHeight,
            backgroundImage: backgroundUrl,
            backgroundColor: this.props.backgroundColor,
          }}
        />

        <div style={{ height: fixedHeaderHeight }} />
      </header>
    );
  }
}
export default StickyHeader;
